export const getSearchParams = () => {
  const url = window.location.href;
  const query = url.split('?')?.[1];
  if (query) {
    // security if the query was before the path
    const search = query.split('#/')[0];
    return new URLSearchParams(search);
  }
  return undefined;
};
